export enum ExternalRiskLevelType {
  High = 1,
  MediumHigh = 2,
  Medium = 3,
  MediumLow = 4,
  Low = 5,
}
